import React from "react";
import { Flex } from "@chakra-ui/react";

import { Footer, NavBar } from "@components"
import ImgSvg from "@assets/Img/imgBackground.svg"


const styles = {
  svg: {
    objectFit: "cover"
  },
  customStyleSvg: {
    display:"flex",
    position: "absolute",
    zIndex: "1",
    top: "0",
    left: "0",
    maxWidth: "100vw",
    maxHeight: "100vh",
    overflow: "hidden",
  },
  customStyleContainer: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    maxWidth: "100vw",
    backgroundColor: "#e5e5e5",
    position: "relative",
  }
};


const Layout = ({ children, menuType, isNavBarVisible, isFooterVisible, ...rest}) => {
  
  return (
    <div style={styles.customStyleContainer} {...rest}>
      <div style={styles.customStyleSvg}>
        <img style={styles.svg} src={ImgSvg} alt="background-img" />
      </div>

      <div style={{ zIndex: "2" }} >
        { isNavBarVisible && <NavBar menuType={menuType} /> }

        <Flex alignItems="center" justifyContent="top" flexDir="column" minHeight='calc(100vh - 120px)'>
          {children && children}
        </Flex>

        { isFooterVisible && <Footer /> }
      </div>
    </div>
  );
}

export default Layout;